export {Home} from './home';
export {About} from './about';
export {LogIn} from './login';
export {Landing} from './landing';
export {NotFound} from './notFound';
export {Book} from './book';
